import { render, staticRenderFns } from "./chatRobot.vue?vue&type=template&id=223e13a3&scoped=true"
import script from "./chatRobot.vue?vue&type=script&lang=js"
export * from "./chatRobot.vue?vue&type=script&lang=js"
import style0 from "./chatRobot.vue?vue&type=style&index=0&id=223e13a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223e13a3",
  null
  
)

export default component.exports